module.exports = __webpack_public_path__ + "42985632436e71ff95cadc749d762a85.svg";